<template>
  <div class="commercial-value">
    <div class="msg-main">
      <div class="msg-title">
        <h1>商业价值</h1>
        <a><img src="../../../assets/images/right-arrow.png"></a>
      </div>
      <div class="content-block">
        <div class="msg-content">
          <div class="tag-title">
            <a @click="chosen" :class="{clicked:chooseBrand}" id="brandTag">品牌宣传</a>
            <a @click="chosen" :class="{clicked:!chooseBrand}" id="userTag">拓展新用户</a>
          </div>
          <div class="animated fadeIn tag-msg" v-if="chooseBrand" :key="1">
            <h1>打造品牌营销力</h1>
            <span>
            九芯净水利用马拉松照片营销,快速传播品牌广告<br>
            有效的扩大了品牌曝光率<br>
            同时也挖掘了“高消费”,“高收入”,“高学历”的潜在用户群体<br>
            提高了企业品牌影响力。
          </span>
          </div>
          <div class="animated fadeIn tag-msg" v-if="!chooseBrand" :key="2">
            <h1>精准挖掘潜在用户</h1>
            <span>
            南方电网通过东莞马拉松照片营销,广告精准覆目标用户<br>
            目标用户自主分享快速裂变,为企业带来海量品牌曝光<br>
            再通过强制微信公众号导流,为企业引流真实用户<br>
            从而获得高转化
          </span>
          </div>
          <el-button round>立即了解</el-button>
        </div>
        <img src="../../../assets/images/branding-promot.png" v-if="chooseBrand" class="animated fadeInRight branding-img" :key="3">
        <img src="../../../assets/images/user-up.png" v-if="!chooseBrand" class="animated fadeInRight user-img" :key="4">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommercialValue',
  data: function () {
    return {
      chooseBrand: 'true'
    }
  },
  methods: {
    chosen (e) {
      if (e.target.id === 'brandTag') {
        this.chooseBrand = true
      } else {
        this.chooseBrand = false
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .commercial-value
    width: 100%
    background-color: #eeeeee
    background-image: url("../../../assets/images/second-background.png")
    background-position: center
    background-size: cover
    .msg-main
      width: 84.4%;
      max-width: 1200px;
      margin: 0 auto
      padding-bottom: 57px
      .msg-title
        margin-left: 71px;
        h1
          padding-top: 55px
          font-weight: 400
          font-size: 32px
          display: inline-block
          margin: 0
        a
          display: inline-block
          vertical-align: bottom
          img
            width: 37px
            margin-left: 30px
            vertical-align: bottom
      .content-block
        .msg-content
          margin: 60px 0 0 71px;
          width: 40%
          display: inline-block
          vertical-align: top
          .tag-title
            font-size: 23px
            display: flex
            a
              padding-bottom: 20px
              cursor: pointer
            .clicked
              font-weight: 500
              border-bottom: 3px solid #ca222e
            a + a
              margin-left: 50px
          .tag-msg
            margin-top: 60px
            h1
              font-size: 22px
              margin-bottom: 0
              font-weight: 400
            span
              display: inline-block
              margin-top: 33px
              font-size: 16px
              line-height: 25px
              color: #5c5c5c
          .el-button
            background-color: #e32232
            color: white
            margin-top: 48px
            width: 208px
            height: 47px
            font-size: 20px
            border: none
            border-radius: 25px
        img
          display: inline-block
          margin-left: 80px
          width: 42%
        /*.branding-img*/
          /*height: 413.13px*/

        /*.user-img*/
          /*height: 413.13px*/

</style>



// WEBPACK FOOTER //
// src/pages/home/components/CommercialValue.vue